export const RecognizeEmailConstants = {
  PageTitleSingleResult: 'Does this email address look familiar? ',
  PageTitleMultipleResults: 'Do any of these email addresses look familiar? ',
  EmailButtonText: 'Yes, that’s me',
  BottomParagraph: 'Don’t recognise any of these email addresses?',
  GetHelpLink: 'Get help',
} as const
